import styles from './LibraryNav.module.css';

interface LibraryNavProps {
  activeNav: string;
  onNavChange: (nav: string) => void;
  counts: {
    all: number;
    recent: number;
    starred: number;
    imported: number;
  };
}

const workspaceItems = [
  { id: 'all', label: 'My Progressions', dotColor: 'var(--gold)' },
  { id: 'recent', label: 'Recent', dotColor: 'var(--terra)' },
  { id: 'starred', label: 'Starred', dotColor: 'var(--c-4)' },
  { id: 'imported', label: 'Imported', dotColor: 'var(--c-2)' },
] as const;

export const LibraryNav: React.FC<LibraryNavProps> = ({
  activeNav,
  onNavChange,
  counts,
}) => {
  return (
    <aside className={styles.nav}>
      <h2 className={styles.brand}>
        N<i>eume</i>
      </h2>

      <div className={styles.group}>
        <span className={styles.groupLabel}>Workspace</span>
        {workspaceItems.map((item) => {
          const count = counts[item.id as keyof typeof counts] ?? 0;
          return (
            <button
              key={item.id}
              className={`${styles.navItem} ${activeNav === item.id ? styles.active : ''}`}
              onClick={() => onNavChange(item.id)}
            >
              <span
                className={styles.dot}
                style={{ background: item.dotColor }}
              />
              <span className={styles.navLabel}>{item.label}</span>
              <span className={styles.count}>{count}</span>
            </button>
          );
        })}
      </div>

      {/* TODO(77630240): re-enable Collections + Library sections when curated content lands */}

      <div className={styles.marginQuote}>
        "The page is older than the ink."
      </div>
    </aside>
  );
};
